import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';

export default function Content({ session }) {
  return (
    <>
      <Row>
        <Col md={6}>
          <dl className="row">
            <dt className="col-sm-3">Name</dt>
            <dd className="col-sm-9 text-in-one-string">{session.chat_info.user_name}</dd>
            <dt className="col-sm-3">Email</dt>
            <dd className="col-sm-9 text-in-one-string">{session.chat_info.user_email}</dd>
            <dt className="col-sm-3">Enterprise</dt>
            <dd className="col-sm-9 text-in-one-string">{session.chat_info.enterprise}</dd>
          </dl>
        </Col>
        <Col md={6}>
          <dl className="row">
            <dt className="col-sm-3 ">Avatar</dt>
            <dd className="col-sm-9 text-in-one-string">
              {session.chat_info.avatar_name}
              &nbsp;
            </dd>
            <dt className="col-sm-3">Type</dt>
            <dd className="col-sm-9">{session.chat_info.session_type}</dd>
            <dt className="col-sm-3">Rating</dt>
            <dd className="col-sm-9">{session.rate > 0 ? session.rate : '- '}</dd>
            <dt className="col-sm-3">Duration</dt>
            <dd className="col-sm-9">
              {Math.round(session.duration * 10 / 60) / 10}
              {' '}
              minutes
            </dd>
          </dl>
        </Col>
      </Row>
      <div>
        <b>Title:</b>
        <p>{session.title}</p>
      </div>
      <div>
        <b>Feedback:</b>
        <p>{session.feedback === '' ? '-' : session.feedback}</p>
      </div>
      <div>
        {session.messages.map((message) => (
          <div key={message.timestamp}>
            <b>{message.role === 'user' ? 'User' : 'AI Coach'}</b>
            <p>{message.content}</p>
            <p>Category: {message.category}</p>
          </div>
        ))}
      </div>
    </>
  );
}

Content.propTypes = {
  session: PropTypes.object.isRequired,
};
